import * as React from "react";
const SvgFiRrWednesday = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-wednesday_svg__a)">
      <path
        fill="#062147"
        d="M19 2h-1V1a1 1 0 1 0-2 0v1H8V1a1 1 0 1 0-2 0v1H5C2.243 2 0 4.243 0 7v12c0 2.757 2.243 5 5 5a1 1 0 1 0 0-2c-1.654 0-3-1.346-3-3v-9h20v3a1 1 0 1 0 2 0V7c0-2.757-2.243-5-5-5M2 8V7c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v1zm19.7 8h-1.5a.8.8 0 0 0-.8.8v6.4a.8.8 0 0 0 .8.8h1.5a2.3 2.3 0 0 0 2.3-2.3v-3.4a2.3 2.3 0 0 0-2.3-2.3m.7 5.7a.7.7 0 0 1-.7.7H21v-4.802h.7a.7.7 0 0 1 .7.7V21.7m-5.801-4.101v1.65H17.7a.8.8 0 1 1 0 1.6h-1.101V22.4H17.7a.8.8 0 1 1 0 1.6h-1.9a.8.8 0 0 1-.8-.8v-6.4a.8.8 0 0 1 .8-.8h1.9a.8.8 0 1 1 0 1.6zm-2.662-.742-.445 6.142c-.043.705-.472 1-.988 1-.342 0-.66-.242-.841-.64l-1.164-2.56-1.164 2.56c-.181.398-.499.64-.841.64-.516 0-.945-.295-.988-1l-.445-6.142a.8.8 0 1 1 1.596-.116l.265 3.66.779-1.713a.877.877 0 0 1 1.596 0l.779 1.713.265-3.66a.8.8 0 0 1 1.596.116"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-wednesday_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWednesday;
